<template>
    <div class="template-color-widget">
        <div class="selected-color-wrapper" @click="switchColorPicker()" ref="template-colorpicker-widget">
            <div class="selected-color" :style="{ backgroundColor: value }">
            </div>
        </div>

        <div class="color-piker-widget" v-if="show_color_picker" v-closable="{
            exclude: ['template-colorpicker-widget'],
            handler: 'closeDropdown',
        }">
            <Sketch :value="value" @input="onChangeColor"></Sketch>
        </div>

    </div>
</template>
<script>
import { eventBus } from "@/main";
import { Sketch } from "vue-color";
export default {
    name: "editor-property",
    components: {
        Sketch,
    },
    props: {
        value: {
            type: String,
            default: "#000000",
        },
    },
    data() {
        return {
            show_color_picker: false,
            timer: null
        };
    },

    mounted() {
        let vm = this;

    },
    methods: {
        onChangeColor(data) {
            let vm = this;
            clearTimeout(vm.timer);
            vm.timer = setTimeout(() => {
                vm.$emit(
                    "input",
                    `rgba(${data.rgba.r}, ${data.rgba.g}, ${data.rgba.b}, ${data.rgba.a})`
                );
            }, 500); // delay emit event by 500ms

        },
        switchColorPicker() {
            let vm = this;
            vm.show_color_picker = !vm.show_color_picker;
        },
        closeDropdown() {
            let vm = this;
            vm.show_color_picker = false;
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.template-color-widget {
    display: flex;
    align-items: center;
    width: 100px;
    position: relative;

    .selected-color-wrapper {
        display: flex;
        align-items: center;
        height: 30px;
        width: 100%;
        padding: 3px;
        border: 1px solid #9f9f9f;
        border-radius: 5px;

        .selected-color {
            width: 100%;
            height: 100%;
            border-radius: 5px;
            cursor: pointer;
        }
    }

    .color-piker-widget {
        position: fixed;
        bottom: 21px;
        right: 272px;
        z-index: 9999;
    }
}
</style>